<template>
	<div class="operation_box">
		<!-- Collection Report -->
		<div class="operation_item">
			<el-dropdown split-button type="primary"
						 @click="showCollectionReport"
						 @command="handleActionCommand"
			>
				<i class="fa fa-euro"></i>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item icon="fa fa-euro" :command="showCollectionReport">
						<span>{{ $t("collection.collectionReport") }}</span>
					</el-dropdown-item>
					<el-dropdown-item icon="fa fa-cloud-download" :command="downloadAllCollectionDocuments">
						<span>{{ $t("collection.downloadCollectionDocument") }}</span>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
import APP from "@/common/appConfig";

export default {
	methods: {
		handleActionCommand(command) {
			if (command) {
				command()
			}
		},
		showCollectionReport() {
			this.params.showCollectionReportModal(this.params.data)
		},
		downloadAllCollectionDocuments() {
			this.params.downloadAllCollectionDocuments(this.params.data.receivableId)
		}
	}
};
</script>